import { useMemo } from 'react'

import { EXPERIMENTS, isAssignedExperimentBucket } from '@src/experiments'

import Product, { ProductLite } from '../domains/Product'
import Bundle from '../domains/Product/BundleProduct'
import ProductTag from '../domains/ProductTag'
import { ProductVariantOption } from '../domains/ProductVariant'
import productHelper from '../helpers/productHelper'

import useMounted from './useMounted'

export const useProductCardTags = ({
  product,
  productTags,
  selectedOptions,
}: {
  product: Product | ProductLite | Bundle
  productTags: ProductTag[]
  selectedOptions: ProductVariantOption[]
}): { applicableTags: ProductTag[]; getItBy24: boolean } => {
  const isMounted = useMounted()

  const { applicableTags, getItBy24 } = useMemo(() => {
    const creditOnProductCardExpControlBucket = isAssignedExperimentBucket(
      EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.experimentName,
      EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.bucketNames.control,
    )
    const allTags = productHelper.getApplicableTags({
      product,
      productTags,
      selectedOptions,
    })

    const getItBy24 = false
    let isOutOfStock = false

    const applicableTags = allTags
      .filter(item => {
        switch (item.value) {
          // hide valentine tag
          case 'GET IT BY 02/14':
            return false
          case 'Today Only':
            return false
          case 'Sold Out':
            isOutOfStock = true
            return true
          default:
            return true
        }
      })
      .filter(
        item => !(creditOnProductCardExpControlBucket && item.value.includes('Earn $') && item.vendor_type == '3P'),
      )

    return {
      applicableTags,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      getItBy24: getItBy24 && !isOutOfStock,
    }
  }, [selectedOptions, productTags, isMounted, product])

  return { applicableTags, getItBy24 }
}
